import React, { useEffect } from "react";
import PageLayout from "../components/ui/PageLayout";

const AboutPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <PageLayout>
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">About Us</h1>
          <p className="text-lg">
            This is the about page. Information about the company and the team
            will be displayed here.
          </p>
        </div>
      </PageLayout>
    </div>
  );
};

export default AboutPage;
